<template>
  <panel class="case-procedures" title="Procedures" color="green-8">
    <case-actions
      :available-actions="procedures"
      :selected-actions="caseConf._treatments"
      :errors="errors"
      :warnings="warnings"
      :readonly="readonly"
      color="green-8"
      @update="update"
    />
  </panel>
</template>

<script>
import { get } from 'lodash';
import Panel from '../../common/Panel';
import CaseActions from '../../common/CaseActions';

export default {
  name: 'case-procedures',
  components: {
    CaseActions,
    Panel,
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    procedures: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    errors() {
      return get(
        this.$store.getters['validation/errorsByFieldAndId'],
        '_treatments',
      );
    },
    warnings() {
      return get(
        this.$store.getters['validation/visibleWarningsByFieldAndId'],
        '_treatments',
      );
    },
  },
  methods: {
    update(procedures) {
      this.$emit('update', { _treatments: procedures });
    },
  },
};
</script>

<style scoped>
</style>
